import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normalizza un input Instagram (username, @username, o URL completo)
 * in un URL valido https://instagram.com/username
 */
export function formatInstagramUrl(input: string | null | undefined): string | null {
  if (!input || input.trim() === '') return null;
  
  let value = input.trim();
  
  // Se è già un URL completo, estrarre lo username e ricostruire
  if (value.includes('instagram.com')) {
    // Rimuovi protocollo, www, e trailing slash
    value = value
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .replace(/^instagram\.com\//, '')
      .replace(/\/$/, '');
    
    // Rimuovi eventuali query params o hash
    value = value.split('?')[0].split('#')[0];
  }
  
  // Rimuovi @ iniziale se presente
  value = value.replace(/^@/, '');
  
  // Rimuovi caratteri non validi (solo lettere, numeri, punti e underscore)
  value = value.replace(/[^\w.]/g, '');
  
  if (!value) return null;
  
  return `https://instagram.com/${value}`;
}
